import React from 'react';
import { ToastContainer, Bounce } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { styled } from '@mui/material/styles';

const StyledToastContainer = styled(ToastContainer)`
  .Toastify__toast {
    font-family: 'Roboto', sans-serif;
    font-size: 12px;
    font-weight: bold; 
    border-radius: 6px;
    padding: 12px 16px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
    min-height: 36px;
    background: #f5fff5; /* Light green background */
    color: #1a3e1a; /* Dark green text */
    border-left: 4px solid #4CAF50; /* Green accent border */
    
    &-body {
      margin: auto 0;
      line-height: 1.4;
    }
    
    &--success {
      background: #f5fff5;
      border-left-color: #2E7D32; /* Darker green for success */
    }
    
    &--error {
      background: #fff5f5;
      border-left-color: #F44336;
    }
    
    &--info {
      background: #f5f9ff;
      border-left-color: #2196F3;
    }
    
    &--warning {
      background: #fffbf5;
      border-left-color: #FF9800;
    }
  }
  
  .Toastify__close-button {
    color: #4CAF50;
    opacity: 0.7;
    align-self: center;
    
    &:hover {
      opacity: 1;
    }
  }
  
  .Toastify__progress-bar {
    height: 2px;
    background: rgba(76, 175, 80, 0.3); /* Subtle green progress bar */
  }
`;

function Toast() {
  return (
    <StyledToastContainer
      position="top-right"
      autoClose={5000}
      hideProgressBar={false}
      newestOnTop={false}
      closeOnClick={false}
      rtl={false}
      pauseOnFocusLoss
      draggable
      pauseOnHover
      transition={Bounce}
    />
  );
}

export default Toast;